module.exports = "<div class=\"aside\" id=\"updateShipping\">\n\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-sidebar-update-shipping/template.html
 ** module id = 329
 ** module chunks = 1
 **/